import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    fallback: String,
  }

  connect() {
    this.element.addEventListener("error", (event) => {
      if (this.element.src != this.fallbackValue) this.element.src = this.fallbackValue
    })
    if (this.element.complete) {
      if (this.element.naturalWidth === 0 && this.element.src != this.fallbackValue) {
        this.element.src = this.fallbackValue
      }
    }
  }
}
